import { Component, OnInit } from '@angular/core'
import { ErrorComponent } from 'app/error/error.component'
@Component({
    selector: 'app-unauthorized',
    templateUrl: '../error/error.component.html',
    styleUrls: ['../error/error.component.css'],
    standalone: false
})
export class UnauthorizedComponent extends ErrorComponent implements OnInit {

    constructor() {
        super()
    }

    override ngOnInit() {
        this.message = 'You are not authorised to access this page'
        this.startAnimation(4, 0, 1)
    }
}
